import Vue from 'vue'

class Toast {
    baseIcons = {
        success: '<path d="M510.545 28.22c-267.043 0-483.521 216.477-483.521 483.52s216.479 483.521 483.521 483.521 483.52-216.479 483.52-483.521S777.588 28.22 510.545 28.22zM776.855 407.855l-315.37 315.37c-9.763 9.763-22.559 14.645-35.355 14.645-12.796 0-25.592-4.882-35.355-14.645l-176.13-176.13c-19.526-19.525-19.526-51.184 0-70.71 19.526-19.526 51.184-19.527 70.711 0L426.13 617.159l280.015-280.015c19.527-19.526 51.184-19.526 70.711 0C796.382 356.671 796.382 388.329 776.855 407.855z" p-id="2629" fill="#ffffff"></path>',
        error: '<path d="M512 0c-281.6 0-512 230.4-512 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0zM761.6 716.8l-44.8 44.8-198.4-198.4-198.4 198.4-44.8-44.8 198.4-198.4-211.2-211.2 44.8-44.8 211.2 211.2 211.2-211.2 44.8 44.8-211.2 211.2L761.6 716.8z" p-id="1854" fill="#ffffff" class=""></path>',
        primary: '<path d="M512.17038 0.86674C229.97937 0.86674 1.214153 229.632981 1.214153 511.823991c0 282.19101 228.765217 510.956228 510.956228 510.956228 282.19101 0 510.956228-228.765217 510.956228-510.956228C1023.126608 229.632981 794.360368 0.86674 512.17038 0.86674zM509.972319 214.231199c37.841863 0 68.529793 30.670533 68.529793 68.492954 0 37.85619-30.68793 68.5257-68.529793 68.5257-37.83777 0-68.509327-30.66951-68.509327-68.5257C441.464015 244.901733 472.134549 214.231199 509.972319 214.231199zM659.867234 808.247144l-273.222755 0 0-35.815717 67.538209 0L454.182688 475.133348c-32.745798 0-40.398082-21.518083-40.398082-38.617529 0-17.096377 7.485485-38.614459 24.585955-38.614459l152.935158 0 0 374.530069 68.561515 0L659.867234 808.247144z" p-id="3967" fill="#ffffff" class="selected"></path>',
        normal: '<path d="M512.17038 0.86674C229.97937 0.86674 1.214153 229.632981 1.214153 511.823991c0 282.19101 228.765217 510.956228 510.956228 510.956228 282.19101 0 510.956228-228.765217 510.956228-510.956228C1023.126608 229.632981 794.360368 0.86674 512.17038 0.86674zM509.972319 214.231199c37.841863 0 68.529793 30.670533 68.529793 68.492954 0 37.85619-30.68793 68.5257-68.529793 68.5257-37.83777 0-68.509327-30.66951-68.509327-68.5257C441.464015 244.901733 472.134549 214.231199 509.972319 214.231199zM659.867234 808.247144l-273.222755 0 0-35.815717 67.538209 0L454.182688 475.133348c-32.745798 0-40.398082-21.518083-40.398082-38.617529 0-17.096377 7.485485-38.614459 24.585955-38.614459l152.935158 0 0 374.530069 68.561515 0L659.867234 808.247144z" p-id="3967" fill="#ffffff" class="selected"></path>'
    }

    constructor ({
                     type = 'error',
                     msg = '',
                     delay = 2.5
                 } = {}) {
        this.unit = 1000
        this.opt = {
            type, msg, delay: delay * this.unit
        }
    }

    alert (msg = '', type = 'error', delay = 2.5) {
        if (msg) this.opt.msg = msg
        if (type) this.opt.type = type
        if (delay) this.opt.delay = delay * this.unit
        this.init(this.opt.msg, this.opt.type, this.opt.delay)
    }

    success (msg = '', delay = 2.5) {
        this.alert(msg, 'success', delay)
    }

    error (msg = '', delay = 2.5) {
        this.alert(msg, 'error', delay)
    }

    init (msg, type, delay) {
        let icon = this.icons(type)
        let ToastTpl = Vue.extend({     // 1、创建构造器，定义好提示信息的模板
            template: `
            <transition name="fade">
            <div class="toast toast-${type}">
                <div class="toast-icon">
                    <svg t="1509609559347" class="icon" style="width: .7em; height: .7em; vertical-align: middle; fill: currentcolor; overflow: hidden; font-size: 64px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1853">
                    ${icon}
</svg>
                </div>
                <div class="toast-title">
                    <div class="message-msg">
                        <p>${msg}</p>
                    </div>
                </div>
            </div>
            </transition>
            `
        })

        let tpl = new ToastTpl().$mount().$el  // 2、创建实例，挂载到文档以后的地方
        document.body.appendChild(tpl)
        setTimeout(function () {        // 4、延迟2.5秒后移除该提示
            document.body.removeChild(tpl)
        }, delay)
    }

    icons (type = 'error') {
        return this.baseIcons[type]
    }

}

Toast.install = function (Vue, options) {
    // 4. 添加实例方法
    Vue.prototype.$toast = new Toast(options)
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Toast)
}

export default Toast



// WEBPACK FOOTER //
// ./src/lib/toast/toast.js